import { HandCoinIcon } from './HandCoinIcon';

/**
 * author: Jeff Anders
 * id 861C015B-47CA-41A6-8994-E43D980ECD58
 * name hand-coin
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-coin.svg
 * tags
 * - Banking 
 */
export const DonationIcon = HandCoinIcon;
export default DonationIcon